export default {
  'pages.login.accountLogin.tab': 'Account Login',
};
